import './App.css';
import Landing from './pages/Landing';
import Mention from './pages/Mention';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
  <Router>
      <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/Mention-légales" element={<Mention />} /> 
      </Routes>
  </Router>
  );
}

export default App;
